// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__2tizp","footerText":"footer_footerText__Qftt8","socials":"footer_socials__2-FJq","button":"footer_button__2DMaZ"};